import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Label from "../../../components/Label/Label";
import Buttons from "../../../components/Controls/Buttons/Button";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const DateInput = ({ label, value, onChange, minDate, maxDate }) => {
  return (
    <DatePicker
      selected={value ? new Date(value) : null}
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={150}
      // popperClassName="custom-datepicker-popper"
      onChange={(date) => {
        onChange(date);
      }}
      dateFormat="dd-MMM-yyyy"
      minDate={minDate}
      maxDate={maxDate}
      customInput={
        <TextField
          label={label}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      }
    />
  );
};

const FiltersPopup = ({
  open,
  onClose,
  filters,
  onChange,
  onReset,
  onGenerate,
  data,
  filterOptions,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ borderRadius: "16px !important", margin: 0 }}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: "276px",
          boxShadow: "none",
          bottom: 0,
          position: "fixed",
          left: 58,
          margin: 0,
          // boxShadow: "none",
          maxHeight: "calc(100vh - 110px)",
          overflow: "scroll",
        },
      }}
    >
      <Box
        sx={{ backgroundColor: "#E8EDF4", minHeight: "calc(100vh - 143px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            fontWeight: 600,
            paddingLeft: "10px",
            alignItems: "center",
            overflow: "hidden",
            height: "38px",
          }}
        >
          Filter
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
            padding: "5px",
            overflow: "auto",
            // height: "calc(100vh - 200px)",
          }}
        >
          <DialogContent
            sx={{
              padding: "0px",
              boxShadow: "none",
              // minHeight: "calc(100vh - 280px)",
              overflow: "auto",
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Configuration Item"}> </Label>
              <TextField
                select
                label="Configuration Item"
                size="small"
                fullWidth
                value={filters?.entity_id}
                onChange={(e) => onChange("entity_id", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {filterOptions?.entities?.map((option) => (
                  <MenuItem key={option.entity_id} value={option.entity_id}>
                    {option.entity_name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Event Name"}> </Label>
              <TextField
                select
                label="Event"
                size="small"
                fullWidth
                value={filters?.event_name}
                onChange={(e) => onChange("event_name", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {filterOptions?.event_names?.map((option) => (
                  <MenuItem key={option.name} value={option.name}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Created By"}> </Label>
              <TextField
                select
                label="Created By"
                size="small"
                fullWidth
                value={filters?.created_by}
                onChange={(e) => onChange("created_by", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {filterOptions?.users?.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                boxShadow: "none",
              }}
            >
              <Label text={"Created at"}> </Label>
              <DateInput
                label="From"
                value={filters?.from_date}
                onChange={(val) => onChange("from_date", val)}
                maxDate={filters.to_date}
              />

              <DateInput
                label="To"
                value={filters?.to_date}
                onChange={(val) => onChange("to_date", val)}
                minDate={filters.from_date}
              />
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Status"}> </Label>
              <TextField
                select
                label="Status"
                size="small"
                fullWidth
                value={filters?.status}
                onChange={(e) => onChange("status", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem key={"ASSIGNED"} value={"ASSIGNED"}>
                  Assigned
                </MenuItem>
                <MenuItem key={"DRAFT"} value={"DRAFT"}>
                  Draft
                </MenuItem>

                {/* {filterOptions?.status?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))} */}
              </TextField>
            </Box>
          </DialogContent>
          <Box
            display="flex"
            justifyContent="end"
            gap={1}
            p={1}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Button variant="outlined" onClick={onReset}>
              Reset
            </Button>
            <Buttons
              text="Submit"
              variant="contained"
              onClick={onGenerate}
              loading={data?.loader}
            ></Buttons>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default FiltersPopup;
